// Shared navigation items used across the application
export const navigationItems = [
    "home",
    "about",
    "education",
    "projects",
    "skills and experience",
    "testimonial",
    "contact"
];

// Mobile navigation items (may differ from desktop)
export const mobileNavigationItems = [
    "home",
    "about",
    "education",
    "projects",
    "skills",
    "testimonial",
    "contact"
];
